import { TrendingUp } from 'lucide-react';
import { useEffect, useState, type ReactElement } from 'react';
import { cn } from '@/helpers/utils';

const ROWS = [
  { label: 'Global Rank', rank: 183, tone: 'text-primary', delta: '42 places' },
  { label: 'Captain Rank', rank: 54, tone: 'text-gold', delta: '12 places' },
  { label: 'Office League', rank: 2, tone: 'text-competitive-blue', delta: '18 pts to catch Alex' },
] as const;

export function LeaderboardPreview(): ReactElement {
  const [showDelta, setShowDelta] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShowDelta(true), 200);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="rounded-2xl border border-border bg-card overflow-hidden shadow-sm">
      {ROWS.map((row, i) => (
        <div key={row.label} className={cn('flex items-center justify-between px-4 py-3', i > 0 && 'border-t border-border/60')}>
          <div>
            <div className="text-[10px] uppercase tracking-wide text-muted-foreground font-semibold">{row.label}</div>
            <div className={cn('text-2xl font-extrabold tabular-nums leading-tight', row.tone)}>
              {`#${row.rank}`}
            </div>
          </div>
          <div
            className={cn(
              'inline-flex items-center gap-1 text-xs font-semibold text-success motion-safe:transition-opacity motion-safe:duration-300',
              showDelta ? 'opacity-100 animate-fade-in' : 'opacity-0',
            )}
          >
            <TrendingUp className="h-3.5 w-3.5" />
            {row.delta}
          </div>
        </div>
      ))}
    </div>
  );
}
